module.exports = __webpack_public_path__ + "img/compact.cf8dcb2d.png";